export default __webpack_public_path__ + "static/media/wedding.d4378bcc.jpg";